import React, { JSX } from 'react';
import { Box, Card, CardContent, CardHeader, Chip, Stack, Typography } from '@mui/material';
import { Build, CheckCircle, Description, Psychology, Star, Work } from '@mui/icons-material';
import * as Types from 'types/types';

export function JobCreatorRequirements(props: {
  jobRequirements: Types.JobRequirements | null;
}): JSX.Element {
  const { jobRequirements } = props;
  if (!jobRequirements) return <></>;

  return (
    <Card elevation={2} sx={{ mt: 3 }}>
      <CardHeader
        title="Job Requirements Analysis"
        avatar={<CheckCircle color="success" />}
        sx={{ pb: 1 }}
      />
      <CardContent sx={{ pt: 0 }}>
        <RequirementSection
          title="Technical Skills (Required)"
          items={jobRequirements.technicalSkills.required}
          icon={<Build color="primary" />}
          required
        />
        <RequirementSection
          title="Technical Skills (Preferred)"
          items={jobRequirements.technicalSkills.preferred}
          icon={<Build color="action" />}
        />
        <RequirementSection
          title="Experience Requirements (Required)"
          items={jobRequirements.experienceRequirements.required}
          icon={<Work color="primary" />}
          required
        />
        <RequirementSection
          title="Experience Requirements (Preferred)"
          items={jobRequirements.experienceRequirements.preferred}
          icon={<Work color="action" />}
        />
        <RequirementSection
          title="Soft Skills"
          items={jobRequirements.softSkills}
          icon={<Psychology color="secondary" />}
        />
        <RequirementSection
          title="Experience"
          items={jobRequirements.experience}
          icon={<Star color="warning" />}
        />
        <RequirementSection
          title="Education"
          items={jobRequirements.education}
          icon={<Description color="info" />}
        />
        <RequirementSection
          title="Certifications"
          items={jobRequirements.certifications}
          icon={<CheckCircle color="success" />}
        />
        <RequirementSection
          title="Preferred Attributes"
          items={jobRequirements.preferredAttributes}
          icon={<Star color="secondary" />}
        />
      </CardContent>
    </Card>
  );
}

function RequirementSection(props: {
  title: string;
  items: string[] | undefined;
  icon: JSX.Element;
  required?: boolean;
}): JSX.Element {
  if (!props.items || props.items.length === 0) return <></>;

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        {props.icon}
        <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 600 }}>
          {props.title}
        </Typography>
        {props.required && <Chip label="Required" size="small" color="error" sx={{ ml: 1 }} />}
      </Box>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {props.items.map(item => (
          <Chip key={item} label={item} variant="outlined" size="small" sx={{ mb: 1 }} />
        ))}
      </Stack>
    </Box>
  );
}
